<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

import Widgets from "./widget.vue";

export default {
  page: {
    title: "Dashboards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Dashboards",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
      ],
    }
  },
  components: {
    Layout,
    PageHeader,
    Widgets,
  },
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row project-wrapper">
            <div class="col-xxl-12">
                <div class="row">
                    
                        <Widgets />
                    
                    <div class="col-xl-4">
                        
                    </div>
                    <div class="col-xl-4">
                        
                    </div>
                </div>
            </div>

            
        </div>

        

        

    </Layout>
</template>